export default __webpack_public_path__ + "img/consultation_zoom-05a7d22180c5b8ed8d2cfcc6f7ae6e4a.png";